import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dispatch } from 'd3-dispatch';

import widgetWrapper from './widgetWrapper';

import {
  formatBytes,
  renderSparkarea,
  formatTimestamp,
} from './widgetUtils';

import './RabbitNodeWidget.scss';

class RabbitNodeWidget extends Component {

  constructor() {
    super();
    this.doD3Rendering = renderSparkarea.bind(this);
    this.chartRef = React.createRef();
    this.currPoint = null;
    this.rabbitState = '';
    this.dispatcher = dispatch('pointenter', 'pointleave');
    this.dispatcher.on('pointenter', ({ value = Number.NaN }) => {
      this.setState({ hoverValue: value });
    });
    this.dispatcher.on('pointleave', () => {
      this.setState({ hoverValue: Number.NaN });
    });
  }

  state = { hoverValue: Number.NaN };

  componentDidMount() {
    window.addEventListener('resize', this.doD3Rendering);
    if (this.props.value.running
      && this.props.value.used !== undefined
      && this.props.value.limit !== undefined) {
      this.doD3Rendering();
    }
  }

  componentDidUpdate(_prevProps, _prevState) {
    if (this.props.value.running
      && this.props.value.used !== undefined
      && this.props.value.limit !== undefined) {
      this.doD3Rendering();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.doD3Rendering);
  }

  render() {
    const {
      title = '',
      value: {
        used,
        limit,
        running,
      } = {},
      thresholds: {
        danger = 0.90,
        warning = 0.75,
      } = {},
      timestamp = '',
    } = this.props;

    let className = '';
    let val = formatBytes(used, 3, true);

    if (this.state.hoverValue) {
      val = formatBytes(this.state.hoverValue, 3, true);
    }

    if (!running) {
      val = 'Not Running';
    } else if (used === undefined || limit === undefined) {
      className = 'danger';
      val = 'No Data';
    }

    this.rabbitState = '';
    if (used >= limit * danger) {
      this.rabbitState = 'danger';
    } else if (used >= limit * warning) {
      this.rabbitState = 'warning';
    } else {
      this.rabbitState = 'success';
    }

    return (
      <div className={`widget-threshold-colors RabbitNodeWidget ${className}`}>
        <div className="header">
          {
            this.props.titleHasInnerHTML ?
              <div className="title" dangerouslySetInnerHTML={{ __html: title }} /> :
              <div className="title">{title}</div>
          }
        </div>
        <div className="content">
          <div className="content-wrapper">
            <div className="widget-value">{val}</div>
            <div className="sparkarea-wrapper">
              <svg className="sparkarea-svg" ref={this.chartRef} />
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="details">{`${formatBytes(limit, 3, true)} Limit`}</div>
          <div className="timestamp">{formatTimestamp(timestamp)}</div>
        </div>
      </div>
    );
  }
}

RabbitNodeWidget.defaultProps = {
  title: '',
  titleHasInnerHTML: false,
  value: null,
  thresholds: {},
  series: null,
  timestamp: '',
};

RabbitNodeWidget.propTypes = {
  title: PropTypes.string,
  titleHasInnerHTML: PropTypes.bool,
  value: PropTypes.shape({
    used: PropTypes.number,
    limit: PropTypes.number,
    running: PropTypes.bool,
  }),
  thresholds: PropTypes.shape({
    danger: PropTypes.number,
    warning: PropTypes.number,
  }),
  series: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.shape,
      value: PropTypes.number,
      auxValue: PropTypes.number,
    })),
    margin: PropTypes.shape({
      top: PropTypes.number,
      right: PropTypes.number,
      left: PropTypes.number,
      bottom: PropTypes.number,
    }),
    points: PropTypes.shape({
      color: PropTypes.string,
      radius: PropTypes.number,
    }),
    colors: PropTypes.arrayOf(PropTypes.string),
    strokeWidth: PropTypes.number,
  }),
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default widgetWrapper(RabbitNodeWidget);
